import { toast as toastify } from 'vue3-toastify';
import AppToast from '@/components/ui/Toast.vue';

/**
 * @typedef {Object} ContentProps
 * @property {string} heading - The main title/heading of the toast notification
 * @property {string} message - The detailed message or description to display in the toast
 * @property {string} icon - The name of the icon to display (e.g., 'help-circle', 'alert-circle', etc.)
 * @property {import('@/constants/colors').SemanticColor} color - The color theme of the toast notification
 */

export function useToast() {
  /**
   * @description function to create a toast notification
   * @param {ContentProps} contentProps - The properties to pass to the toast component
   * @param {Object} options - The options to pass to the toastify function
   * @returns {Function} - The toast function
   */
  const toast = (contentProps = {}, options = { position: 'bottom-right' }) => {
    return toastify(AppToast, {
      contentProps,
      ...options,
    });
  };

  /**
   * @description dismiss a specific toast notification by id
   * @param {import('vue3-toastify').Id} id - the id returned by `toast()`
   */
  const dismissToast = (id) => {
    if (id != null) {
      toastify.remove(id);
    }
  };

  return { toast, dismissToast };
}
